var _path, _path2, _rect, _path3, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.705 4.444H13.74C11.675 4.444 10 6.028 10 7.98v24.04c0 1.952 1.675 3.535 3.74 3.535h11.965c2.064 0 3.74-1.583 3.74-3.535V7.98c0-1.952-1.676-3.536-3.74-3.536zm-5.983 27.753c-1.241 0-2.243-.948-2.243-2.121 0-1.174 1.002-2.122 2.243-2.122 1.242 0 2.244.948 2.244 2.122 0 1.173-1.002 2.12-2.244 2.12z",
    fill: "url(#phone-key_svg__paint0_linear_3841_67348)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.705 4.444H13.74C11.675 4.444 10 6.028 10 7.98v24.04c0 1.952 1.675 3.535 3.74 3.535h11.965c2.064 0 3.74-1.583 3.74-3.535V7.98c0-1.952-1.676-3.536-3.74-3.536zm-5.983 27.753c-1.241 0-2.243-.948-2.243-2.121 0-1.174 1.002-2.122 2.243-2.122 1.242 0 2.244.948 2.244 2.122 0 1.173-1.002 2.12-2.244 2.12z",
    fill: "url(#phone-key_svg__paint1_linear_3841_67348)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.697 25.697a3.362 3.362 0 015.384 3.882l5.22 5.219.002 1.505-2.918.003v-1.42h-1.42v-1.419h-1.42v-1.42l-.966-.966a3.363 3.363 0 01-3.882-5.384zm1.069 2.506a1.017 1.017 0 101.437-1.438 1.017 1.017 0 00-1.437 1.438z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone-key_svg__paint0_linear_3841_67348",
    x1: 29.832,
    y1: 4.73,
    x2: 1.569,
    y2: 22.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone-key_svg__paint1_linear_3841_67348",
    x1: 29.401,
    y1: 4.513,
    x2: 1.56,
    y2: 21.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688FA5"
  })))));
}

export default __webpack_public_path__ + "./fonts/phone-key.3b6b354df921328e36d21a248e1fc173.svg";
export { SvgPhoneKey as ReactComponent };